import type { FC, ReactNode } from 'react'

import { useDashboard } from '@/components/dashboard/dashboard-provider'

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog'

interface KeyProps {
    children: ReactNode
}

const Key: FC<KeyProps> = ({ children }): ReactNode => (
    <kbd className='inline-flex h-6 min-w-6 items-center justify-center rounded-md border bg-muted px-1.5 font-mono text-[11px] font-medium text-foreground'>
        {children}
    </kbd>
)

export const ShortcutsDialog: FC = (): ReactNode => {
    const { shortcutsOpen, setShortcutsOpen, isMac } = useDashboard()
    const modifier = isMac ? '⌘' : 'Ctrl'

    const shortcuts: { label: string, keys: string[] }[] = [
        { label: 'Buka pencarian cepat', keys: [modifier, 'K'] },
        { label: 'Buka pencarian dari mana saja', keys: ['/'] },
        { label: 'Ciutkan atau lebarkan sidebar', keys: [modifier, 'B'] },
        { label: 'Tutup dialog atau menu', keys: ['Esc'] }
    ]

    return (
        <Dialog open={shortcutsOpen} onOpenChange={setShortcutsOpen}>
            <DialogContent className='sm:max-w-md'>
                <DialogHeader>
                    <DialogTitle>
                        Pintasan keyboard
                    </DialogTitle>
                    <DialogDescription>
                        Bekerja lebih cepat tanpa meninggalkan keyboard.
                    </DialogDescription>
                </DialogHeader>

                <ul className='divide-y rounded-lg border'>
                    {shortcuts.map((shortcut) => (
                        <li key={shortcut.label} className='flex items-center justify-between gap-4 px-3 py-2.5 text-sm'>
                            <span className='text-foreground'>
                                {shortcut.label}
                            </span>

                            <span className='flex shrink-0 items-center gap-1'>
                                {shortcut.keys.map((key) => (
                                    <Key key={key}>
                                        {key}
                                    </Key>
                                ))}
                            </span>
                        </li>
                    ))}
                </ul>
            </DialogContent>
        </Dialog>
    )
}
